<template>
  <div class="sp-template">
    <div class="h-title">新建订单</div>
    <el-card class="box-card">
      <el-form :model="orderForm.deliveryDetail" size="small" :rules="orderFormRule" ref="orderForm1">
        <el-form-item label="取件方式" :label-width="formLabelWidth">
          <el-radio :disabled="disableForClaim" v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="PICK_UP_FROM_CUSTOMER">预约上门取件</el-radio>
          <span style="margin-left:30px;color:#666;">我们将在1-2天内上门取件，为收货方便，请提前准备好货物！当运费小于500元时，按货物重量收取费用，详情请查看</span>
          <el-button size="mini" type="text">《上门取件上说明》</el-button>
          <br />
          <el-radio :disabled="disableForClaim" v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY">送货至仓库</el-radio>
          <span style="margin-left:30px;color:#666;">请根据您的货物地址，选择距离货物最近的收货仓库</span>
          <br />
          <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY_BY_EXPRESS">快递至仓库</el-radio>
          <span style="margin-left:30px;color:#666;">请根据您的货物地址，选择距离货物最近的收货仓库</span>
        </el-form-item>
        <el-form-item label="取件地址" :label-width="formLabelWidth">
          <el-select v-model="shippingId" placeholder="请选择" @change="selectShippingAddress" v-show="orderForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'">
            <el-option v-for="item in shippingList" :key="item.id" :label="item.address" :value="item.id">
              <span>{{ item.country+" "+item.province+" "+item.city+" "+item.address+" "+item.name+" "+item.phone}}</span>
            </el-option>
          </el-select>
          <el-button size="small" type="primary" @click="addressDialogPop()" v-show="orderForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'">添加地址</el-button>

          <el-table :data="new Array(orderForm.deliveryDetail)" :show-header="false" class="table-list" style="width: 100%" v-show="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' && false">
            <el-table-column prop="province" label="地址" width="70"></el-table-column>
            <el-table-column prop="city" label="地址" width="90"></el-table-column>
            <el-table-column prop="addressFirst" label="地址" width="260"></el-table-column>
            <el-table-column prop="contractName" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑地址</el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>

        <!-- <el-form-item label="仓库地址" :label-width="formLabelWidth">
            <el-table :data="userCarry" :show-header="false" class="table-list" style="width: 100%"  >
            <el-table-column label="地址" width="460">
              <template slot-scope="scope">
                【{{scope.row.title}}】{{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="contractName" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column label="距离" width="160">
              <template slot-scope="scope">
                {{scope.row.distance + 'km'}}&nbsp;
                <span v-if="scope.row.distance == mapObj.minNumber" style="color: #ff9976">(距离最近)</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button size="mini" type="text" :disabled="disableForClaim" @click="handleMapEdit(scope.$index, scope.row)">更换仓库</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item> -->

        <el-form-item label="交货仓库地址" :label-width="formLabelWidth">
          <el-select v-model="warehouseId" filterable v-if="flag" placeholder="请选择" @change="selectWarehouse">
            <el-option v-for="item in warehouse" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <el-table :data="userCarry" :show-header="false" class="table-list" style="width: 100%">
            <el-table-column label="仓库名称" width="230">
              <template slot-scope="scope">
                {{scope.row.title}}
              </template>
            </el-table-column>
            <el-table-column label="地址" width="230">
              <template slot-scope="scope">
                {{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item :label="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' ? '预约取件时间' : '预计送达时间'" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType!='DELIVERY_BY_EXPRESS'" prop="appointmentAt">
          <el-date-picker v-model="orderForm.deliveryDetail.appointmentAt" :picker-options="appointmentAtOptions" type="datetime" placeholder="选择日期" 
          value-format="yyyy-MM-dd HH:mm:ss" :default-value="new Date()"></el-date-picker>
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="快递公司" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressCompany">
              <el-input :disabled="disableForClaim" v-model="orderForm.deliveryDetail.expressCompany" auto-complete="off" placeholder="快递公司"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="快递单号" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressNumber">
              <el-input :disabled="disableForClaim" v-model="orderForm.deliveryDetail.expressNumber" auto-complete="off" placeholder="快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          
      </el-form>
      <h3 class="sp-card-title">订单信息
        <el-checkbox style="margin-left:20px;" v-model="fbaChecked" @change="changeShippingAddressType">FBA地址</el-checkbox>
      </h3>
      <el-form :model="orderForm.shippingDetail" size="small" :rules="orderFormRule2" ref="orderForm2">
        <el-row v-show="!fbaChecked">
          <el-col :span="10">
            <el-form-item label="客户单号" :label-width="formLabelWidth" prop="customerOrderNumber">
              <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
            </el-form-item>
            <el-form-item label="联系人" :label-width="formLabelWidth" prop="shippingContractName">
              <el-input v-model="orderForm.shippingDetail.contractName" auto-complete="off" placeholder="如已存在联系人，则自动补充后面信息"></el-input>
            </el-form-item>
            <el-form-item label="国家" :label-width="formLabelWidth" prop="shippingCountry">
              <el-select v-model="shippingDetail.countryId" @change="queryProvince" filterable>
                <el-option v-for="(country,i) in initialDataCountry" :key="i" :label="country.code" :value="country.id"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="城市" :label-width="formLabelWidth" prop="shippingCity">
              <el-select v-if="initialDataCity.length > 0" v-model="shippingDetail.cityId" @change="selectCity" filterable>
                <el-option v-for="(city,i) in initialDataCity" :key="i" :label="city.nameEn" :value="city.id"></el-option>
              </el-select>
              <el-input v-else v-model="orderForm.shippingDetail.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="公司名称" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.companyName" auto-complete="off" placeholder="公司名称"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" :label-width="formLabelWidth" prop="shippingPhone">
              <el-input v-model="orderForm.shippingDetail.phone" auto-complete="off" placeholder="联系电话"></el-input>
            </el-form-item>
            <el-form-item label="州/省" :label-width="formLabelWidth" prop="shippingProvince">
              <el-select v-if="initialDataProvince.length > 0" v-model="shippingDetail.provinceId" @change="queryCity" filterable>
                <el-option v-for="(province, i) in initialDataProvince" :key="i" :label="province.nameEn + '(' + province.code + ')' " :value="province.id"></el-option>
              </el-select>
              <el-input v-else v-model="orderForm.shippingDetail.province"></el-input>
            </el-form-item>
            <el-form-item label="目的邮编" :label-width="formLabelWidth" prop="zipcode">
              <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="目的邮编"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址1" :label-width="formLabelWidth" prop="shippingAddressFirst">
              <el-input v-model="orderForm.shippingDetail.addressFirst" auto-complete="off" class="width50"></el-input>
            </el-form-item>
            <el-form-item label="详细地址2" :label-width="formLabelWidth" prop="shippingAddressSecond">
              <el-input v-model="orderForm.shippingDetail.addressSecond" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="fbaChecked">
          <el-col :span="10">
            <el-form-item label="客户单号" :label-width="formLabelWidth">
              <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
            </el-form-item>
            <el-form-item label="FBA仓码" :label-width="formLabelWidth">
              <el-select v-model="shippingDetail.fbaWarehouseCode" filterable clearable @change="changeFbaWarehouseCode">
                <el-option v-for="(fba,i) in initialDataFbaAddress" :key="i" :label="fba.warehouseCode" :value="fba.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省/州" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.province" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
            </el-form-item>
            <el-form-item label="目的邮编" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="根据仓码自动匹配，可修改"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="FBA号" :label-width="formLabelWidth">
              <el-input v-model="orderForm.customerRefnumber.fbaNumber" auto-complete="off" placeholder="FBA号"></el-input>
            </el-form-item>
            <el-form-item label="目的国家" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.country" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
            </el-form-item>
            <el-form-item label="目的城市" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.city" auto-complete="off" placeholder="根据仓码自动匹配，可修改"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.addressFirst" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Amazon Reference ID" :label-width="formLabelWidth">
              <el-input v-model="orderForm.amazonReferenceId" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <h3 v-if="false" class="sp-card-title">本地地址</h3>
        <el-row v-if="false">
          <el-col :span="10">
            <el-form-item label="联系人" :label-width="formLabelWidth" prop="shippingContractName">
              <el-input v-model="orderForm.localLanguage.contractName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="省/州" :label-width="formLabelWidth">
              <el-input v-model="orderForm.localLanguage.province" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="目的国家" :label-width="formLabelWidth">
              <el-input v-model="orderForm.localLanguage.country" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="目的城市" :label-width="formLabelWidth">
              <el-input v-model="orderForm.localLanguage.city" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址1" :label-width="formLabelWidth">
              <el-input v-model="orderForm.localLanguage.addressFirst" auto-complete="off" class="width50"></el-input>
            </el-form-item>
            <el-form-item label="详细地址2" :label-width="formLabelWidth">
              <el-input v-model="orderForm.localLanguage.addressSecond" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <h3 class="sp-card-title">商品信息
        <el-checkbox :disabled="disableForClaim" style="margin-left:20px;" v-model="formData.usMeasure">以承运商测量数据为准</el-checkbox>
      </h3>
      <el-form :model="orderForm.packingList" size="small" :rules="orderFormRule3" ref="orderForm3">
        <el-row>
          <el-col :span="10">
            <el-form-item label="货物类型" :label-width="formLabelWidth" prop="goodsType">
              <el-select v-model="orderForm.packingList.goodsType">
                <el-option v-for="(d,i) in goodsTypeList" :label="d.name" :key="i" :value="d.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="一般贸易" :label-width="formLabelWidth">
              <el-checkbox v-model="orderForm.generalTrade" :checked="false"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10"> 
            <el-form-item label="上传箱明细" :label-width="formLabelWidth">
              <el-checkbox v-model="uploadCartonDetail"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否购买保险" :label-width="formLabelWidth">
              <el-checkbox v-model="orderForm.purchaseInsurance" :checked="false"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="uploadCartonDetail">
          <el-col :span="10">
            <el-form-item label="模板下载" :label-width="formLabelWidth">
              <a href="../../static/template/FBA-US-A-carton-sample.xlsx" class="download-template">美国空运模板</a>
              <a href="../../static/template/FBA-EU-A-carton-sample.xlsx" class="download-template">欧洲空运模板</a>
              <a href="../../static/template/FBA-S-carton-sample.xlsx" class="download-template">国际海运模板</a>
              <a href="../../static/template/new-railway-sample.xlsx" class="download-template">国际铁运模板</a>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="uploadCartonDetail">
          <el-col :span="10">
            <el-form-item label="文件上传" :label-width="formLabelWidth">
              <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile" :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!uploadCartonDetail">
          <el-col :span="10">
            <el-form-item label="箱子规格" :label-width="formLabelWidth">
              <el-radio :disabled="disableForClaim" v-model="productForm.guigeRadio" label="1">全部相同</el-radio>
              <el-radio :disabled="disableForClaim" v-model="productForm.guigeRadio" label="2">不同</el-radio>
              <el-tooltip class="item" effect="dark" content="选全部相同则填写" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="货物箱数" :label-width="formLabelWidth" prop="totalCarton">
              <el-input :disabled="disableForClaim" v-model="orderForm.packingList.totalCarton" auto-complete="off" type="number" placeholder="货物箱数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="!formData.usMeasure && productForm.guigeRadio == 1 && !uploadCartonDetail">
          <el-col :span="10">
            <el-form-item label="单箱尺寸(cm)" :label-width="formLabelWidth" v-show="!formData.usMeasure">
              <el-input v-model="guige.long" auto-complete="off" class="size" placeholder="长"></el-input>
              <el-input v-model="guige.width" auto-complete="off" class="size" placeholder="宽"></el-input>
              <el-input v-model="guige.height" auto-complete="off" class="size" placeholder="高"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="单箱货物重量(kg)" :label-width="formLabelWidth" v-show="!formData.usMeasure">
              <el-input v-model="guige.weight" auto-complete="off" placeholder="单箱货物重量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-button :disabled="disableForClaim" type="text" @click="handleEditGuige" v-show="productForm.guigeRadio == 2 && !uploadCartonDetail">添加箱子信息</el-button>
        <el-table :data="guigeArr" border v-show="productForm.guigeRadio == 2 && !uploadCartonDetail" class="m-b-20">
          <el-table-column property="customerCartonNumber" label="客户箱号"></el-table-column>
          <el-table-column property="number" label="箱数"></el-table-column>
          <el-table-column property="long" label="长(cm)"></el-table-column>
          <el-table-column property="width" label="宽(cm)"></el-table-column>
          <el-table-column property="height" label="高(cm)"></el-table-column>
          <el-table-column property="weight" label="毛重(kg)"></el-table-column>
          <el-table-column label="SKU信息">
            <template slot-scope="scope">
              <p v-for="(d,i) in scope.row.skus" :key="i">{{d.sku}} * {{d.number}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="measureEditSkus(scope.$index)">添加/编辑SKU</el-button>
              <i v-show="!disableForClaim" class="el-icon-edit-outline" @click="handleEditGuige( scope.row, scope.$index)"></i>
              <i v-show="!disableForClaim" class="el-icon-delete" @click="handleDeleteGuige(scope.row, scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-row v-show="!uploadCartonDetail">
          <el-col :span="10" v-show="!formData.usMeasure">
            <el-form-item label="总体积(cbm)" :label-width="formLabelWidth" v-show="!formData.usMeasure">
              <el-input v-model="allTiji" auto-complete="off" placeholder="总体积"></el-input>
              <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="总重量(kg)" :label-width="formLabelWidth" v-show="!formData.usMeasure">
              <el-input v-model="allWeight" auto-complete="off" placeholder="总重量"></el-input>
              <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="单箱SKU信息" :label-width="formLabelWidth" v-show="productForm.guigeRadio == '1' && !uploadCartonDetail">
          <p v-for="(d,i) in spList" :key="i">{{d.sku}} * {{d.number}}</p>
          <el-button type="text" @click="editCartonSkus">添加SKU</el-button>
        </el-form-item>
        <el-form-item v-if="isJP && false" label="自有清关行" :label-width="formLabelWidth">
          <el-select v-model="orderForm.customsId" clearable>
            <el-option v-for="(customs,i) in filterCustomsList" :key="i" :label="customs.customsName" :value="customs.customsId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button size="small" @click="back">返 回</el-button>
          <el-button size="small" type="primary" @click="createOrderSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 地图 -->
    <!-- <sp-amap id="sp-amap" v-if="initialDataWarehouseAddress.length != 0" width="100%" :class="{isOpen: isOpen}" :markers="initialDataWarehouseAddress" :isOpen="isOpen" @get-map-form="getMapForm" @get-geocoder="getGeocoder"></sp-amap> -->

    <!-- 上门取件弹层 -->
    <el-dialog title="编辑地址" :visible.sync="addressFormVisible">
      <el-form size="small" :model="addressForm">
        <el-form-item label="州/省" :label-width="formLabelWidth">
          <el-select v-model="deliveryDetail.provinceId" @change="queryCityOfChina" filterable>
            <el-option v-for="(province,i) in initialDataProvinceChina" :key="i" :label="province.nameCn" :value="province.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" :label-width="formLabelWidth">
          <el-select v-model="orderForm.deliveryDetail.city" filterable>
            <el-option v-for="(city,i) in initialDataCityChina" :key="i" :label="city.nameCn" :value="city.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input v-model.lazy="orderForm.deliveryDetail.addressFirst" placeholder="详细地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model.lazy="orderForm.deliveryDetail.contractName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth">
          <el-input v-model.lazy="orderForm.deliveryDetail.phone" placeholder="电话"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddressOfDeliver">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 非上门取件弹层 -->
    <el-dialog title="选取地址" :visible.sync="mapAddressFormVisible" class="gaide-map">
      <!--高德地图-->
      <div ref="spAmap"></div>
      <el-form size="small" class="m-t-20">
        <el-form-item label="已选地址" label-width="70px">
          <b v-text="mapObj.title"></b>
          <span v-text="mapObj.address"></span>
        </el-form-item>
        <el-form-item label="联系人" label-width="70px">
          <span v-text="mapObj.name"></span>
        </el-form-item>
        <el-form-item label="联系电话" label-width="70px">
          <span v-text="mapObj.phone"></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSmenSaveMap">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 添加SKU -->
    <el-dialog class="sp-info-box" title="商品信息" :visible.sync="listTable" @close="skuEditClose">
      <div class="">
        <div style="margin-bottom:10px;">
          <div class="clearfix">
            <div style="float:right;">
              <button type="button" class="el-button el-button--default el-button--small" @click="spHandleEdit">
                <span>新增</span>
              </button>
              <button type="button" class="el-button el-button--default el-button--small" @click="lishiTable = true">
                <span>历史商品列表</span>
              </button>
              <button type="button" class="el-button el-button--default el-button--small" v-show="false">
                <span>批量导入商品</span>
              </button>
            </div>
          </div>
        </div>
        <el-table :data="spList" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="sku" label="SKU">
          </el-table-column>
          <el-table-column prop="nameCn" label="中文品名"></el-table-column>
          <el-table-column prop="nameEn" label="英文品名"></el-table-column>
          <el-table-column prop="hscode" label="海关编码"></el-table-column>
          <el-table-column prop="price" label="申报价值"></el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <img width="65" height="45" :src="scope.row.picture">
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="spHandleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="spHandleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="skuSaveSp">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 添加箱子信息 -->
    <el-dialog :title="cartonDialogTitle" :visible.sync="addGuigeShow">
      <el-form size="small" :model="addGuige" :rules="rulesAddGuige" ref="addGuige">
        <el-form-item v-show="false">
          <el-input v-model="addGuigeIndex" type="number" placeholder="index"></el-input>
        </el-form-item>
        <el-form-item label="客户箱号" :label-width="formLabelWidth" class="must">
          <el-input v-model="addGuige.customerCartonNumber" placeholder="客户箱号(如填客户箱号,箱数只能为1)"></el-input>
        </el-form-item>
        <el-form-item label="箱数" :label-width="formLabelWidth" class="must" prop="number">
          <el-input v-model="addGuige.number" type="number" placeholder="箱数"></el-input>
        </el-form-item>
        <el-form-item label="长(CM)" :label-width="formLabelWidth" class="must" prop="long" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.long" type="number" placeholder="长"></el-input>
        </el-form-item>
        <el-form-item label="宽(CM)" :label-width="formLabelWidth" class="must" prop="width" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.width" type="number" placeholder="宽"></el-input>
        </el-form-item>
        <el-form-item label="高(CM)" :label-width="formLabelWidth" class="must" prop="height" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.height" type="number" placeholder="高"></el-input>
        </el-form-item>
        <el-form-item label="毛重(KG)" :label-width="formLabelWidth" class="must" prop="weight" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.weight" type="number" placeholder="毛重"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" class="erro-info">
          <div class="erro-info-text" v-text="addGuigeErro"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="handleSaveguige">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 历史商品列表弹层 -->
    <el-dialog title="历史商品列表" :visible.sync="lishiTable">
      <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input v-model="conditions.sku" placeholder="SKU/中文/英文品名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="skuHistorySearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="productData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sku" label="SKU">
        </el-table-column>
        <el-table-column prop="nameCn" label="中文品名"></el-table-column>
        <el-table-column prop="nameEn" label="英文品名"></el-table-column>
        <el-table-column prop="hscode" label="海关编码"></el-table-column>
        <el-table-column prop="price" label="申报价值"></el-table-column>
        <el-table-column prop="img" label="图片">
          <template slot-scope="scope">
            <img width="65" height="45" :src="scope.row.picture">
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="productHistoryList.total" :page-size="productHistoryList.pageSize" :current-page="productHistoryList.page" @current-change="currentPage" class="t-a-r m-t-20"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleSaveSp">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增商品信息弹层 -->
    <el-dialog :title="editProductTitle" :visible.sync="addSPinfo">
      <el-form size="small" label-width="80px" :model="tmpProduct" :rules="rulesTmpProduct" ref="tmpProduct">
        <el-form-item label="SKU" prop="sku">
          <el-input placeholder="id" v-show="false" v-model="tmpProduct.id"></el-input>
          <el-input placeholder="SKU" v-model.lazy="tmpProduct.sku"></el-input>
        </el-form-item>
        <el-form-item label="中文品名" prop="nameCn">
          <el-input placeholder="中文品名" v-model.lazy="tmpProduct.nameCn"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" prop="nameEn">
          <el-input placeholder="英文品名" v-model.lazy="tmpProduct.nameEn"></el-input>
        </el-form-item>
        <el-form-item label="长(cm)" prop="length">
          <el-input type="number" placeholder="长" v-model.lazy="tmpProduct.length"></el-input>
        </el-form-item>
        <el-form-item label="宽(cm)" prop="width">
          <el-input type="number" placeholder="宽" v-model.lazy="tmpProduct.width"></el-input>
        </el-form-item>
        <el-form-item label="高(cm)" prop="height">
          <el-input type="number" placeholder="高" v-model.lazy="tmpProduct.height"></el-input>
        </el-form-item>
        <el-form-item label="单个净重(kg)" prop="singleNetWeight">
          <el-input v-model.lazy="tmpProduct.singleNetWeight" type="number" placeholder="单个净重"></el-input>
        </el-form-item>
        <el-form-item label="单个毛重(kg)" prop="weight">
          <el-input placeholder="单个毛重(kg)" type="number" v-model.number="tmpProduct.weight"></el-input>
        </el-form-item>
        <el-form-item label="中国海关编码" prop="hscode">
          <el-input placeholder="中国海关编码" v-model.lazy="tmpProduct.hscode"></el-input>
        </el-form-item>
        <el-form-item label="目的国海关编码" prop="euHsCode">
          <el-input placeholder="目的国海关编码" v-model.lazy="tmpProduct.euHsCode"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model.lazy="tmpProduct.brand" placeholder="品牌"></el-input>
        </el-form-item>
        <el-form-item label="材质" prop="material">
          <el-input v-model.lazy="tmpProduct.material" placeholder="材质"></el-input>
        </el-form-item>
        <el-form-item label="用途" prop="purpose">
          <el-input v-model.lazy="tmpProduct.purpose" placeholder="用途"></el-input>
        </el-form-item>
        <el-form-item label="ASIN或销售链接" prop="asin">
          <el-input v-model.lazy="tmpProduct.asin" placeholder="ASIN或销售链接"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-input v-model.lazy="tmpProduct.model" placeholder="型号"></el-input>
        </el-form-item>
        <el-form-item label="单个产品申报价值" prop="price">
          <el-select v-model="tmpProduct.currency" placeholder="请选择币种" size="small" class="w-150">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-input type="number" placeholder="单个产品申报价值"  v-model.number="tmpProduct.price"></el-input>
        </el-form-item>
        <el-form-item label="商品图片" :label-width="formLabelWidth" prop="img">
          <el-upload action="#" :file-list="imgFile" list-type="picture-card" :limit="1" :on-change="imgChange" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-show="nextAddProductButton" @click="handleAddSpContinue">继续添加</el-button>
        <el-button type="success" @click="handleAddSp">完 成</el-button>
      </div>
    </el-dialog>

    <!-- 添加地址 -->
    <el-dialog title="添加地址" :visible.sync="addressDialogVisible" width="60%">
      <addressDialog :shippingForm="shippingForm" v-on:closeAddressPanel="closeAddressPanel()" />
    </el-dialog>

  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate.js'
import addressDialog from "../usercenter/address_dialog";

function clone(obj) {
  if (!obj || typeof obj != "object") return obj;
  let _newObj = new Object();
  for (let key in obj) {
    _newObj[key] = clone(obj[key]);
  }
  return _newObj;
}

export default {
  components: {
    addressDialog
  },
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!this.formData.usMeasure) {
        if (!/^\d+.?\d{0,4}$/.test(value) || value <= 0) {
          callback(new Error("请输入大于0的整数或小数,小数最大精确4位"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkInteger = (rule, value, callback) => {
      if (!/^\d+$/.test(value) || value <= 0) {
        callback(new Error("请输入大于0的整数"));
      } else {
        callback();
      }
    };
    var checkFormHeadDate = (rule, value, callback) => {
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "PICK_UP_FROM_CUSTOMER"
      ) {
        if (!value || value == "") {
          callback(new Error("日期不能为空，请选择日期"));
        } else {
          //地址校验
          if (
            this.orderForm.deliveryDetail.addressFirst == "" ||
            this.orderForm.deliveryDetail.city == "" ||
            this.orderForm.deliveryDetail.contractName == "" ||
            this.orderForm.deliveryDetail.phone == "" ||
            this.orderForm.deliveryDetail.province == ""
          ) {
            callback(new Error("请点击'编辑地址'按钮补全地址信息"));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    };
    var checkFormHeadText = (rule, value, callback) => {
      if (this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS") {
        if (!value || value == "") {
          callback(new Error("快递信息不能为空"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkFormBodyTextorderNumber = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.customerRefnumber.customerOrderNumber == "")
          callback(new Error("客户单号必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextaddressFirst = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.addressFirst == "")
          callback(new Error("详细地址1必填"));
        callback();
      } else {
        callback();
      }
    };

    var checkFormBodyTextcity = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.city == "")
          callback(new Error("城市必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcontractName = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.contractName == "")
          callback(new Error("联系人必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyText = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcountry = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextphone = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.phone == "")
          callback(new Error("联系电话"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextprovince = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.province == "")
          callback(new Error("省份&州必选"));
        callback();
      } else {
        callback();
      }
    };

    var checkFormBottomTotalCarton = (rule, value, callback) => {
      if (!value || !parseInt(value) || isNaN(value) || parseInt(value) <= 0) {
        callback(new Error("货物箱数必须为大于0的整数"));
      } else {
        callback();
      }
    };

    return {
      isJP: false,
      conditions: {
        sku: ""
      },
      addressDialogVisible: false,
      uploadCartonDetail: false,
      shippingForm: {},
      imgFile: [],
      //高德地图
      isInit: true,
      isOpen: false,
      markers: [
        {
          id: "",
          title: "【东莞仓】",
          position: [113.753228, 22.9833],
          address: "广东省东莞市南城街道东骏豪苑(东骏路)",
          name: "blry",
          phone: "13713262222"
        },
        {
          title: "【龙岗仓】",
          position: [114.234824, 22.723301],
          address: "广东省深圳市龙岗区龙城街道宏兴苑",
          name: "blry",
          phone: "13713263333"
        },
        {
          title: "【坂田仓】",
          position: [114.07314, 22.62579],
          address: "广东省深圳市龙岗区坂田第三工业区二栋一楼",
          name: "blry",
          phone: "13713261111"
        }
      ],
      mapObj: {},
      userCarry: [
        {
          title: "",
          address: "",
          name: "",
          phone: "",
          distance: ""
        }
      ],
      mapAddressFormVisible: false,
      fbaChecked: true,
      formData: {
        usMeasure: false
      },

      form: {
        test: "",
        radio: "1"
      },
      orderForm: {
        orgOwner: "",
        orgOp: "",
        warehoustCode: "",
        productId: "",
        remark: "",
        customsId: "",
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: formatDate(new Date()),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        },
        shippingDetail: {
          contractName: "amazon",
          phone: "999999999",
          country: "",
          countryId: "",
          province: "",
          city: "",
          zipcode: "",
          addressFirst: "",
          addressSecond: "",
          fbaWarehouseCode: "",
          companyName: ""
        },
        packingList: {
          goodsType: "",
          totalCarton: "",
          cartonDetails: []
        },
        localLanguage: {
          contractName: "",
          country: "",
          province: "",
          city: "",
          addressFirst: "",
          addressSecond: ""
        },
        generalTrade: false,
        mazonReferenceId: "",
        purchaseInsurance: false
      },
      shippingDetail: {
        countryId: "",
        provinceId: "",
        cityId: ""
      },
      deliveryDetail: {
        provinceId: ""
      },
      productData: [],
      tmpProduct: {
        id: "",
        currency: "",
        sku: "",
        weight: "",
        nameCn: "",
        nameEn: "",
        hscode: "",
        price: "",
        img: ""
      },
      orderFormRule: {
        appointmentAt: [
          {
            validator: checkFormHeadDate,
            trigger: "change"
          }
        ],
        expressCompany: [
          {
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        expressNumber: [
          {
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        customerOrderNumber: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ]
      },
      orderFormRule3: {
        goodsType: [
          {
            required: true,
            message: "请选择货物类型",
            trigger: "change"
          }
        ],
        totalCarton: [
          {
            validator: checkFormBottomTotalCarton,
            trigger: "blur"
          }
        ]
      },
      orderFormRule2: {
        customerOrderNumber: [
          {
            validator: checkFormBodyTextorderNumber,
            trigger: "change"
          }
        ],
        shippingPhone: [
          {
            validator: checkFormBodyTextphone,
            trigger: "change"
          }
        ],
        zipcode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        shippingContractName: [
          {
            validator: checkFormBodyTextcontractName,
            trigger: "change"
          }
        ],
        shippingCountry: [
          {
            validator: checkFormBodyTextcountry,
            trigger: "change"
          }
        ],
        shippingAddressFirst: [
          {
            validator: checkFormBodyTextaddressFirst,
            trigger: "change"
          }
        ]
      },
      rulesTmpProduct: {
        sku: [
          {
            required: true,
            message: "请输入SKU",
            trigger: "blur"
          }
        ],
        nameCn: [
          {
            required: true,
            message: "请输入中文品名",
            trigger: "blur"
          }
        ],
        nameEn: [
          {
            required: true,
            message: "请输入英文品名",
            trigger: "blur"
          }
        ],
        length: [
          {
            required: true,
            message: "请填写长",
            trigger: "blur"
          }
        ],
        width: [
          {
            required: true,
            message: "请填写宽",
            trigger: "blur"
          }
        ],
        height: [
          {
            required: true,
            message: "请填写高",
            trigger: "blur"
          }
        ],
        singleNetWeight: [
          {
            required: true,
            message: "请填写单个净重",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "请填写单个毛重",
            trigger: "blur"
          }
        ],
        hscode: [
          {
            required: true,
            message: "请输入海关编码",
            trigger: "blur"
          }
        ],
        euHsCode: [
          {
            required: true,
            message: "请填写目的国海关编码",
            trigger: "blur"
          }
        ],
        brand: [
          {
            required: true,
            message: "请填写品牌",
            trigger: "blur"
          }
        ],
        material: [
          {
            required: true,
            message: "请填写材质",
            trigger: "blur"
          }
        ],
        purpose: [
          {
            required: true,
            message: "请填写用途",
            trigger: "blur"
          }
        ],
        asin: [
          {
            required: true,
            message: "请填写ASIN",
            trigger: "blur"
          }
        ],
        model: [
          {
            required: true,
            message: "请填写型号",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入单个产品申报金额",
            trigger: "blur"
          },
          {
            type: "number",
            message: "申报金额必须是数字",
            trigger: "blur"
          }
        ]
      },
      productHistoryList: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      productForm: {
        test: "",
        guigeRadio: "1",
        select: "shanghai",
        boxNumber: 0
      },
      //上门取件
      tableAddressData: [
        {
          address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
          name: "blry",
          phone: "18682152960"
        }
      ],
      addressForm: {
        address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
        name: "blry",
        phone: "18682152960"
      },
      addressFormVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      options: [
        {
          value: "RMB",
          label: "人民币"
        },
        {
          value: "HKD",
          label: "港币"
        },
        {
          value: "GBP",
          label: "英镑"
        },
        {
          value: "USD",
          label: "美元"
        },
        {
          value: "JPY",
          label: "日元"
        },
        {
          value: "EUR",
          label: "欧元"
        }
      ],
      value: "",
      guige: {
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      guigeArr: [],
      addGuige: {
        customerCartonNumber: "",
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      addGuigeErro: "",
      addGuigeShow: false,
      listTable: false, //添加sku
      addSPinfo: false,
      lishiTable: false,
      spList: [], //sku列表
      spListIndex: "",
      spListIndexData: "",
      standardSkus: [], //每箱同sku
      lishiList: [
        {
          sku: "HF001",
          zhName: "黑色签字笔",
          enName: "pen",
          code: "547896542",
          money: "￥5.00",
          img:
            "https://y.gtimg.cn/music/photo_new/T001R300x300M000002J4UUk29y8BY.jpg?max_age=2592000"
        }
      ],
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      initialDataFbaAddress: [],
      customsList: [],
      initialDataCountry: [],
      initialDataProvince: [],
      initialDataCity: [],
      initialDataProvinceChina: [],
      initialDataCityChina: [],
      initialDataWarehouseAddress: [],
      currentWarehouseAddress: "",
      addImg: "",
      cartonDialogTitle: "添加货物信息",
      addGuigeIndex: "",
      rulesAddGuige: {
        number: [
          {
            validator: checkInteger,
            trigger: "blur"
          }
        ],
        long: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        width: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        height: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        weight: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ]
      },
      appointmentAtOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              let _tomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24
                ).toLocaleDateString()
              );
              picker.$emit("pick", _tomorrow);
            }
          },
          {
            text: "后天",
            onClick(picker) {
              let _afterTomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24 * 2
                ).toLocaleDateString()
              );
              picker.$emit("pick", _afterTomorrow);
            }
          }
        ],
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      editProductTitle: "新增商品信息",
      nextAddProductButton: true,
      clone(obj) {
        if (!obj || typeof obj != "object") return obj;
        let _newObj = new Object();
        for (let key in obj) {
          _newObj[key] = clone(obj[key]);
        }
        return _newObj;
      },
      shippingList: [],
      shippingId: "",
      disableForClaim: false,
      flag: false,
      goodsTypeList: [],
      warehouseData: [],
      warehouseId: "",
      warehouse: [],
      fileList: [],
      templateFile: ""
    };
  },
  created() {
    var _this = this;
    setTimeout(() => {
      _this.onLoad();
      _this.queryCustomsList();
    }, 100);
  },
  computed: {
    filterCustomsList: function() {
      var key = this.key;
      var customsList = this.customsList;
      return customsList.filter(function(item) {
        return item.status > 0;
      });
    },
    //总体积
    allTiji: function() {
      if (this.productForm.guigeRadio == "1") {
        if (
          this.orderForm.packingList.totalCarton &&
          this.guige.long &&
          this.guige.width &&
          this.guige.height
        ) {
          return (
            (parseInt(this.orderForm.packingList.totalCarton) *
              parseInt(this.guige.long) *
              parseInt(this.guige.width) *
              parseInt(this.guige.height)) /
            1000000
          ).toFixed(4);
        } else {
          return 0;
        }
      } else {
        if (this.guigeArr.length > 0) {
          let num = 0;
          this.guigeArr.forEach((d, i) => {
            if (d.number && d.long && d.width && d.height) {
              num +=
                (parseInt(d.number) *
                  parseInt(d.long) *
                  parseInt(d.width) *
                  parseInt(d.height)) /
                1000000;
            }
          });
          return num.toFixed(4);
        } else {
          return 0;
        }
      }
    },
    //总重量
    allWeight: function() {
      if (this.productForm.guigeRadio == "1") {
        let weight =
          this.guige.weight && this.orderForm.packingList.totalCarton
            ? parseInt(this.orderForm.packingList.totalCarton) *
              parseFloat(this.guige.weight)
            : 0;
        if (this.orderForm.packingList.totalCarton && this.guige.weight) {
          return weight.toFixed(4);
        } else {
          return 0;
        }
      } else {
        if (this.guigeArr.length == 0) return 0;
        let num = 0;
        this.guigeArr.forEach((d, i) => {
          if (d.number && d.weight) {
            num += parseInt(d.number) * parseInt(d.weight);
          }
        });
        return num.toFixed(4);
      }
    }
  },
  watch: {
    //监听规格是否相同
    "productForm.guigeRadio": function() {
      this.guige = {
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.guigeArr = [];
    }
  },
  methods: {
    onLoad() {
      let _this = this;
      _this.loadGoodsType();
      _this.queryCountrys();
      _this.queryProvinceOfChina();
      _this.loadProducts();
    },
    initialFormStatus() {
      let _this = this;
      let claim = _this.$route.query.claim;
      if (claim && claim != "") {
        _this.disableForClaim = true;
        _this.orderForm.deliveryDetail.deliveryType = "DELIVERY_BY_EXPRESS";
        _this.formData.usMeasure = true;
        _this.productForm.guigeRadio = "2";

        //查询claim
        _this.$request1
          .post(
            '/claim/query',
            {
                id: claim,
                warehouseId: "",
                expressCompany: "",
                expressCode: "",
                orderId: "",
                claimed: false,
                startDate: "",
                endDate: "",
                currentPage: 1,
                pageSize: 1000
              },
            {
              withCredentials: true
            }
          )
          .then(function(res) {
            if (res.data.success) {
              _this.orderForm.deliveryDetail.expressNumber =
                res.data.data[0].expressCode;
              _this.orderForm.deliveryDetail.expressCompany =
                res.data.data[0].expressCompany;
              _this.orderForm.packingList.totalCarton = res.data.data[0].qty;
              res.data.data[0].cartonCodes.split(",").forEach((d, i) => {
                let addGuige = {
                  customerCartonNumber: d,
                  number: 1,
                  long: "",
                  width: "",
                  height: "",
                  weight: ""
                };
                _this.guigeArr.push(addGuige);
              });
              _this.$request1({
                  method: 'GET',
                  url: '/warehouse/list',
                  xhrFields: {
                    withCredentials: true
                  }
                })
                .then(response => {
                  _this.warehouseData = response.data.data;
                  response.data.data.forEach((d, i) => {
                    d.title = d.name;
                    d.position = d.position.split(",");
                  });
                  _this.initialDataWarehouseAddress = response.data.data;

                  _this.initialDataWarehouseAddress.forEach((d, i) => {
                    if (d.id == res.data.data[0].warehouseId) {
                      _this.currentWarehouseAddress = d;
                    }
                  });
                })
                .catch(error => {
                  console.log(error);
                });
            } else {
              _this.$message.error(res.data.message);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    back() {
      this.$router.go(-1);
    },
    //高德地图保存地址
    handleSmenSaveMap() {
      this.mapAddressFormVisible = false;
      this.userCarry[0].title = this.mapObj.title;
      this.userCarry[0].address = this.mapObj.address;
      this.userCarry[0].name = this.mapObj.name;
      this.userCarry[0].phone = this.mapObj.phone;
      this.userCarry[0].distance = this.mapObj.distance;
    },
    //点击仓库
    getMapForm(val) {
      this.mapObj = val;
      // console.log("选择仓库： " + JSON.stringify(val));
      this.currentWarehouseAddress = val;
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS"
      ) {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
        this.orderForm.deliveryDetail.contractName = val.receiptPersonName;
        this.orderForm.deliveryDetail.phone = val.receiptPersonPhone;
        this.orderForm.deliveryDetail.country = val.countryCode;
        this.orderForm.deliveryDetail.province = val.province;
        this.orderForm.deliveryDetail.city = val.city;
        this.orderForm.deliveryDetail.addressFirst = val.address;
      } else {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
      }

      if (this.isInit) {
        this.userCarry[0].title = val.name;
        this.userCarry[0].address = val.address;
        this.userCarry[0].name = val.receiptPersonName;
        this.userCarry[0].phone = val.phone;
        this.userCarry[0].distance = val.distance;
        this.isInit = false;
      }
    },
    //获取经纬度：
    getGeocoder(val) {
      console.log("获取经纬度： " + JSON.stringify(val));
    },
    //地图编辑地址
    handleMapEdit(index, row) {
      var self = this;
      this.mapAddressFormVisible = true;
      if (!this.isOpen) {
        clearTimeout(timer);
        let timer = setTimeout(function() {
          self.$refs.spAmap.appendChild(document.getElementById("sp-amap"));
          self.isOpen = true;
        }, 50);
      }
    },
    //编辑地址
    handleEdit(index, row) {
      this.addressFormVisible = true;
      console.log(index, row);
    },
    //------------------箱子信息-----------------------------------------//
    closeUploadFile() {
      this.templateFile = "";
      this.$refs.uploadExcel.clearFiles();
      this.dialogUpLoadVisible = false;
    },
    fileChange(file, fileList) {
      this.templateFile = file.raw;
    },
    exceedFile(file, fileList) {
      fileList[0].name = file[0].name;
      fileList[0].raw = file[0];
      fileList[0].size = file[0].size;
      this.templateFile = file[0];
    },
    //保存
    handleSaveguige() {
      let _this = this;
      let _valid = false;
      _this.$refs["addGuige"].validate(valid => {
        if (!valid) {
          _valid = false;
        } else {
          _valid = true;
        }
      });
      if (!_valid) {
        return false;
      }
      for (let key in _this.addGuige) {
        let item = _this.addGuige[key];
        if (
          !_this.formData.usMeasure &&
          (!item || isNaN(item) || parseFloat(item) <= 0)
        ) {
          //SPFunc.spAlert(_this, "必须大于0");
          //return;
        }
      }
      this.addGuigeShow = false;
      if (this.addGuigeIndex !== undefined && !isNaN(this.addGuigeIndex)) {
        this.guigeArr.splice(this.addGuigeIndex, 1, this.addGuige);
      } else {
        this.guigeArr.push(this.addGuige);
      }
      this.addGuigeIndex = undefined;
      this.addGuige = {
        customerCartonNumber: "",
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
    },
    //新增/编辑箱子信息
    handleEditGuige(item, index) {
      this.addGuigeShow = true;
      this.addGuigeIndex = index;
      this.addGuige = {
        customerCartonNumber: "",
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.cartonDialogTitle = "添加货物信息";
      if (index || index >= 0) {
        this.cartonDialogTitle = "编辑货物信息";
        this.addGuige = item;
      }
    },
    measureEditSkus(index) {
      //箱子规格不同编辑sku
      let _this = this;
      if (_this.guigeArr[index]) {
        if (_this.guigeArr[index].skus) {
          _this.spList = JSON.parse(JSON.stringify(_this.guigeArr[index].skus));
        } else {
          _this.guigeArr[index].skus = new Array();
          _this.spList = JSON.parse(JSON.stringify(_this.guigeArr[index].skus));
        }
        _this.spListIndex = index;
        _this.spListIndexData = _this.guigeArr[index];
        _this.listTable = true;
      }
    },
    //删除
    handleDeleteGuige(item, index) {
      this.guigeArr.splice(index, 1);
    },
    //-------------------商品信息------------------
    //新增/编辑商品信息
    spHandleEdit(index, row) {
      let _this = this;
      _this.addSPinfo = true;
      _this.imgFile = [];
      debugger
      if (row) {
        _this.editProductTitle = "编辑商品信息";
        _this.nextAddProductButton = false;
        _this.tmpProduct = row;
        let file = new Object();
        file.url = row.picture;
        _this.imgFile.push(file);
      } else {
        _this.editProductTitle = "新增商品信息";
        _this.nextAddProductButton = true;
       _this.tmpProduct={
        id: "",
        currency: "",
        sku: "",
        weight: "",
        nameCn: "",
        nameEn: "",
        hscode: "",
        price: "",
        img: ""
      }
        _this.addImg = "";
      }
    },
    //删除商品信息
    spHandleDelete(index, row) {
      this.spList.splice(index, 1);
    },
    //历史商品列表选中
    handleSelectionChange(val) {
      this.spListSelection = val;
    },
    //历史商品列表保存
    handleSaveSp() {
      this.lishiTable = false;
      this.spList = [];
      this.spListSelection.forEach((d, i) => {
        let _d = this.clone(d);
        this.spList.push(_d);
      });
    },

    currentPage(page) {
      this.productHistoryList.page = page;
      let sku = this.conditions.sku;
      this.loadProducts(sku);
    },
    skuEditClose() {
      let _this = this;
      let _removeIndex = new Array();
      if (_this.spList) {
        for (let i = 0; i < _this.spList.length; i++) {
          if (!_this.spList[i].number || _this.spList[i].number <= 0) {
            _this.spList.splice(i, 1);
            i--;
          }
        }
      }
      console.log(_this.spList);
    },
    //sku数据保存
    skuSaveSp() {
      let _this = this;
      let _isFailed = false;
      _this.spList.forEach((data, index) => {
        if (!data.number || data.number <= 0 || isNaN(data.number)) {
          _isFailed = true;
        }
      });
      if (_isFailed) {
        _this.$message.error("SKU数量必须为大于0的数字");
      } else {
        _this.listTable = false;
      }
      if (_this.spListIndexData && _this.spListIndexData != "") {
        _this.spListIndexData.skus = JSON.parse(JSON.stringify(_this.spList));
        _this.$set(_this.guigeArr, _this.spListIndex, _this.spListIndexData);
      }
      _this.standardSkus = _this.spList;
    },
    //历史搜索
    skuHistorySearch() {
      this.productHistoryList.page = 1;
      this.loadProducts(this.conditions.sku);
    },
    loadProducts(sku) {
      //初始化sku
      let _this = this;
      _this.$request1
        .post(
          '/sku/query',
          {
              currentPage: _this.productHistoryList.page,
              pageSize: _this.productHistoryList.pageSize,
              sku: sku
            },
          {
            withCredentials: true,
            // headers: {
            //   "content-type": "application/json"
            // }
          }
        )
        .then(res => {
          if (res.data && res.data.data.length > 0) {
            _this.productData = res.data.data;
            _this.productHistoryList.total = res.data.total;
          } else {
            _this.productData = []
            _this.productHistoryList.total = 0;
            // _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    //新增/编辑商品信息保存
    handleAddSp(index, row) {
      this.addProduct(true);
    },
    handleAddSpContinue() {
      this.addProduct(false);
    },
    getFormData(form, pic) {
      let _this = this;
      var formData = new FormData();
      for (var key in form) {
        formData.append(key, form[key]);
      }
      formData.append("picture", pic);
      return formData;
    },
    addProduct(closeEdit) {
      let _this = this;
      let _valid = true;
      _this.$refs["tmpProduct"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }
      let form = _this.tmpProduct;
      let formData = _this.getFormData(form, _this.addImg);

      _this.$request1
        .post(
          '/sku',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              //添加到历史数据并添加到列表
              if (!_this.tmpProduct || !_this.tmpProduct.id) {
                _this.spList.push(res.data.data[0]);
                _this.productData.push(res.data.data[0]);
                _this.productHistoryList.total += 1;
              }
              _this.spList.forEach((item, index) => {
                res.data.data.forEach((data, i) => {
                  if (item.sku == data.sku) {
                    _this.$set(item, "picture", data.picture);
                  }
                });
              });
              _this.productData.forEach((item, index) => {
                res.data.data.forEach((data, i) => {
                  if (item.sku == data.sku) {
                    _this.$set(item, "picture", data.picture);
                  }
                });
              });
            }
            if (closeEdit) {
              _this.addSPinfo = false;
            } else {
              _this.tmpProduct={
                id: "",
                currency: "",
                sku: "",
                weight: "",
                nameCn: "",
                nameEn: "",
                hscode: "",
                price: "",
                img: ""
              }
              _this.addImg = "";
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    // 图片本地上传预览
    previewFiles() {
      var preview = document.querySelector(".file-content img");
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
            preview.src = reader.result;
            preview.style.width = "50px";
            preview.style.height = "50px";
            preview.style.display = "block";
          } else {
            SPFunc.spAlert(
              _this,
              "请上传合法的图片类型，如:jpg, jpeg, png, gif"
            );
          }
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    editCartonSkus() {
      let _this = this;
      _this.listTable = true;
      _this.spList = _this.standardSkus;
      _this.spListIndexData = null;
      _this.spListIndex = -1;
    },
    saveAddressOfDeliver() {
      let _this = this;
      _this.addressFormVisible = false;
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (_this.deliveryDetail.provinceId == d.id) {
          _this.orderForm.deliveryDetail.province = d.nameCn;
        }
      });
    },
    changedeliveryType(v) {
      let _this = this;
      if (v == "DELIVERY" || v == "DELIVERY_BY_EXPRESS") {
        //送货到仓库
        _this.orderForm.warehoustCode = _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.warehouseCode =
          _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.contractName =
          _this.currentWarehouseAddress.receiptPersonName;
        _this.orderForm.deliveryDetail.phone =
          _this.currentWarehouseAddress.receiptPersonPhone;
        _this.orderForm.deliveryDetail.country =
          _this.currentWarehouseAddress.countryCode;
        _this.orderForm.deliveryDetail.province =
          _this.currentWarehouseAddress.province;
        _this.orderForm.deliveryDetail.city =
          _this.currentWarehouseAddress.city;
        _this.orderForm.deliveryDetail.addressFirst =
          _this.currentWarehouseAddress.address;
      } else if (v == "PICK_UP_FROM_CUSTOMER") {
        //上门取件
        _this.orderForm.deliveryDetail.contractName = "";
        _this.orderForm.deliveryDetail.phone = "";
        _this.orderForm.deliveryDetail.country = "";
        _this.deliveryDetail.provinceId = "";
        _this.orderForm.deliveryDetail.province = "";
        _this.orderForm.deliveryDetail.city = "";
        _this.orderForm.deliveryDetail.addressFirst = "";
        if (_this.shippingList && _this.shippingList.length > 0) {
          let _find = false;
          _this.shippingList.forEach((d, i) => {
            if (d.defaultAddress) {
              _find = true;
              _this.selectShippingAddress(d.id);
            }
          });
          if (!_find) {
            _this.selectShippingAddress(_this.shippingList[0].id);
          }
        }
      }
    },
    queryCountrys() {
      var _this = this;
      _this.$request1
        .get(
          '/country-filter-channel',
          {
            params: {
              channelId: _this.$route.query.product
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCountry = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
          _this.queryAddress("SHIPPING");
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearchCountry(queryString, cb) {
      var restaurants = this.initialDataCountry;
      restaurants.forEach((d, i) => {
        d.value = d.nameEn;
      });
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    queryProvince(countryId) {
      var _this = this;
      _this.initialDataCountry.forEach((d, i) => {
        if (d.id == _this.shippingDetail.countryId) {
          _this.orderForm.shippingDetail.country = d.code;
          _this.orderForm.localLanguage.country = d.localLanguage;
        }
      });

      if (
        _this.orderForm.shippingDetail.country == "JP" ||
        _this.orderForm.shippingDetail.country == "Japan"
      ) {
        _this.isJP = true;
      } else {
        _this.isJP = false;
      }

      _this.$request1
        .get(
          '/province/' + countryId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvince = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvinceChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCity(provinceId) {
      var _this = this;
      _this.initialDataProvince.forEach((d, i) => {
        if (d.id == _this.shippingDetail.provinceId) {
          _this.orderForm.shippingDetail.province = d.code;
          _this.orderForm.localLanguage.province = d.localLanguage;
        }
      });
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCity = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectCity() {
      var _this = this;
      _this.initialDataCity.forEach((d, i) => {
        if (d.id == _this.shippingDetail.cityId) {
          _this.orderForm.shippingDetail.city = d.nameEn;
          _this.orderForm.localLanguage.city = d.localLanguage;
        }
      });
    },
    queryCityOfChina(provinceId) {
      var _this = this;
      _this.orderForm.deliveryDetail.city = "";
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCityChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    buildingOrderForm() {
      //校验表单格式
      let _this = this;
      let _productId = _this.$route.query.product;

      if (!_productId || _productId == "") {
        _this.$message.error(
          "未选择客户和产品，请回退到订单页面重新选择新建订单!"
        );
        return false;
      }
      _this.orderForm.orgOp = "";
      _this.orderForm.productId = _productId;
      _this.orderForm.orgOwner = null;
      _this.orderForm.warehoustCode = _this.currentWarehouseAddress.id;
      if (_this.fbaChecked) {
        _this.orderForm.shippingDetail.contractName = "amazon";
        _this.orderForm.shippingDetail.phone = "9999999999";
      }
      let _validHead = true;
      _this.$refs["orderForm1"].validate(valid => {
        if (!valid) {
          _validHead = false;
        }
      });

      let _validBody = true;
      _this.$refs["orderForm2"].validate(valid => {
        if (!valid) {
          _validBody = false;
        }
      });
      let _validBottom = true;
      _this.$refs["orderForm3"].validate(valid => {
        if (!valid) {
          _validBottom = false;
        }
      });
      if (!_validHead || !_validBody || !_validBottom) {
        return false;
      }
      let _realTotalCount = 0;
      if (_this.productForm.guigeRadio == 2 && !_this.uploadCartonDetail) {
        if (!_this.guigeArr || _this.guigeArr.length <= 0) {
          _this.$message.error("箱子信息和sku信息必填");
          return false;
        } else {
          let _checkout = true;
          _this.guigeArr.forEach((d, i) => {
            if (!d.skus || d.skus.length <= 0) {
              _checkout = false;
            }
            if (!d.number || d.number <= 0 || isNaN(d.number)) {
              _checkout = false;
            } else {
              _realTotalCount += parseInt(d.number);
            }
            if (!_this.formData.usMeasure) {
              if (!d.long || d.long <= 0) {
                _checkout = false;
              }
              if (!d.width || d.width <= 0) {
                _checkout = false;
              }
              if (!d.height || d.height <= 0) {
                _checkout = false;
              }
              if (!d.weight || d.weight <= 0) {
                _checkout = false;
              }
            }
          });
          if (!_checkout) {
            _this.$message.error("箱子信息和sku信息必填,且箱明细数据必须大于0");
            return false;
          }
        }
      }

      if (!_this.uploadCartonDetail) {
        let _totalCarton = parseInt(_this.orderForm.packingList.totalCarton);
        var cartonDetails = new Array();
        if (_this.productForm.guigeRadio == 1) {
          //箱子规格相同
          if (!_this.formData.usMeasure) {
            for (let key in _this.guige) {
              if (!_this.guige[key] || parseFloat(_this.guige[key]) <= 0) {
                _this.$message.error("箱子件毛体和数量必填");
                return;
              }
            }
          }
          if (!_this.standardSkus || _this.standardSkus.length <= 0) {
            _this.$message.error("SKU信息必填");
            return;
          }
          var item = new Array();
          _this.standardSkus.forEach((d, i) => {
            var obj = new Object();
            obj.sku = d.sku;
            obj.qty = d.number;
            item.push(obj);
          });

          for (let i = 0; i < _totalCarton; i++) {
            var cartonDetail = new Object();
            if (!_this.formData.usMeasure) {
              cartonDetail.length = parseFloat(_this.guige.long);
              cartonDetail.width = parseFloat(_this.guige.width);
              cartonDetail.height = parseFloat(_this.guige.height);
              cartonDetail.weight = parseFloat(_this.guige.weight);
            } else {
              cartonDetail.length = 0;
              cartonDetail.width = 0;
              cartonDetail.height = 0;
              cartonDetail.weight = 0;
            }
            cartonDetail.customerCartonNumber =
              _this.guige.customerCartonNumber;
            cartonDetail.items = item;
            cartonDetails.push(cartonDetail);
          }
        } else {
          //箱子规格不同_totalCarton
          if (_realTotalCount != _totalCarton) {
            _this.$message.error(
              "箱规格不相同时，界面上填的货物箱数必须和明细里填的货物箱数的总数一致。"
            );
            return false;
          }
          _this.guigeArr.forEach((d, i) => {
            let _number = parseInt(d.number);

            var item = new Array();
            d.skus.forEach((d, i) => {
              var obj = new Object();
              obj.sku = d.sku;
              obj.qty = d.number;
              item.push(obj);
            });

            for (let i = 0; i < _number; i++) {
              var cartonDetail = new Object();
              if (!_this.formData.usMeasure) {
                cartonDetail.length = parseFloat(d.long);
                cartonDetail.width = parseFloat(d.width);
                cartonDetail.height = parseFloat(d.height);
                cartonDetail.weight = parseFloat(d.weight);
              } else {
                cartonDetail.length = 0;
                cartonDetail.width = 0;
                cartonDetail.height = 0;
                cartonDetail.weight = 0;
              }
              cartonDetail.customerCartonNumber =
                _this.guige.customerCartonNumber;
              cartonDetail.items = item;
              cartonDetails.push(cartonDetail);
            }
          });
        }
        _this.orderForm.packingList.cartonDetails = cartonDetails;
      }
      return true;
    },
    createOrderSubmit() {
      //提交订单
      var _this = this;
      if (!_this.buildingOrderForm()) {
        return;
      }
      var formData = new FormData();
      formData.append("uploadCartonDetail", _this.uploadCartonDetail);
      for (var key in _this.orderForm) {
        if (
          key == "customerRefnumber" ||
          key == "deliveryDetail" ||
          key == "packingList" ||
          key == "shippingDetail" ||
          key == "localLanguage"
        ) {
          formData.append(key, JSON.stringify(_this.orderForm[key]));
        } else {
          formData.append(key, _this.orderForm[key]);
        }
      }

      if (_this.uploadCartonDetail) {
        if (!_this.templateFile || _this.templateFile.length == 0) {
          this.$message.error("请选择文件。");
          return false;
        } else {
          formData.append("template", _this.templateFile);
        }
      }
      formData.append("productType", _this.$route.query.productType);

      _this.$request1
        .post(
          '/order',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.result.success) {
            if (_this.disableForClaim) {
              //调用认领
              _this.$request1
                .post(
                  '/claiming',
                  {
                    id: _this.$route.query.claim
                  },
                  {
                    withCredentials: true
                  }
                )
                .then(res => {
                  console.log(res);
                  if (res.data.success) {
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
                .catch(error => {
                  console.log(error);
                });
            }

            _this.$alert(res.data.orderId, "创建订单成功,订单号为:", {
              confirmButtonText: "确定",
              callback: action => {
                _this.$router.push("/order");
              }
            });
          } else {
            _this.$alert(res.data.result.message, "订单创建失败,异常提示:", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryWarehouseData() {
      this.$request1({
        method: 'GET',
        url: '/warehouse',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.warehouseData = response.data.data;
          console.log("warehoueAddress", this.warehouseData);
          this.flag = true;
          // this.getMapForm(this.warehouseData[0]);
          if (this.warehouseData.length == 1) {
            this.flag = false;
          }
          this.warehouse = [];
          response.data.data.forEach((d, i) => {
            d.title = d.name;
            d.position = d.position.split(",");

            let warehouse = { id: "", title: "" };
            warehouse.id = d.id;
            warehouse.title = d.name;
            this.warehouse.push(warehouse);
          });
          this.initialDataWarehouseAddress = response.data.data;
          this.initialDataWarehouseAddress = response.data.data;
          let bantianWarehouse = this.warehouseData.find(item => {
            return item.name === "星邮坂田仓";
          });
          if (bantianWarehouse) {
            this.warehouseId = bantianWarehouse.id;
            this.getMapForm(bantianWarehouse);
          } else {
            this.warehouseId = this.warehouseData[0].id;
            this.getMapForm(this.warehouseData[0]);
          }
          // this.currentWarehouseAddress = response.data.data[0];
          this.initialFormStatus();
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeFbaWarehouseCode() {
      let _this = this;
      _this.initialDataFbaAddress.forEach((d, i) => {
        if (d.id == _this.shippingDetail.fbaWarehouseCode) {
          _this.orderForm.shippingDetail.country = d.country;
          _this.orderForm.shippingDetail.province = d.state;
          _this.orderForm.shippingDetail.city = d.city;
          _this.orderForm.shippingDetail.zipcode = d.postCode;
          _this.orderForm.shippingDetail.addressFirst = d.address;
          _this.orderForm.shippingDetail.fbaWarehouseCode = d.warehouseCode;

          if (
            _this.orderForm.shippingDetail.country == "JP" ||
            _this.orderForm.shippingDetail.country == "Japan"
          ) {
            _this.isJP = true;
          } else {
            _this.isJP = false;
          }

          _this.orderForm.localLanguage.country = "";
          _this.orderForm.localLanguage.province = "";
          _this.orderForm.localLanguage.city = "";

          _this.getLocalLanguageCountry(d.country);
          setTimeout(() => {
            _this.getLocalLanguageProvince(d.state);
          }, 500);
          setTimeout(() => {
            _this.getLocalLanguageCity(d.city);
          }, 1000);
        }
      });
    },
    getLocalLanguageCountry(country) {
      this.initialDataCountry.forEach((item, i) => {
        if (country == item.code) {
          this.orderForm.localLanguage.country = item.localLanguage;
          this.queryProvince(item.id);
        }
      });
    },
    getLocalLanguageProvince(province) {
      this.initialDataProvince.forEach((item, i) => {
        if (province == item.code || province == item.nameEn) {
          this.orderForm.localLanguage.province = item.localLanguage;
          this.queryCity(item.id);
        }
      });
    },
    getLocalLanguageCity(city) {
      this.initialDataCity.forEach((item, i) => {
        if (city == item.nameEn) {
          this.orderForm.localLanguage.city = item.localLanguage;
        }
      });
    },
    queryFbaAddress() {
      let _this = this;
      _this.$request1
        .get(
          '/fba-warehouse',
          {
            params: {
              channelId: _this.$route.query.product
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataFbaAddress = response.data.data;
          }
          _this.queryWarehouseData();
          _this.loadCustomerAddress();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //查询清关行&报关行
    queryCustomsList() {
      let _this = this;
      _this.$request1
        .get(
          '/customs/load',
          {
            params: {
              customsName: "",
              customsType: "",
              currentPage: 1,
              pageSize: 100
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.customsList = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadCustomerAddress() {
      // let _this = this;
      // let _orgOwner = _this.$route.query.customer;
      // if (!_orgOwner || _orgOwner.length == 0) {
      // } else {
      //   _this.$request1
      //     .get(
      //       jsRoutes.controllers.customer.CustomerController.loadCustomerAddress(_orgOwner),
      //       {
      //         withCredentials: true,
      //         headers: {
      //           "content-type": "application/json"
      //         }
      //       }
      //     )
      //     .then(res => {
      //       if (res.data.success && res.data.total > 0) {
      //         _this.orderForm.deliveryDetail.province = res.data.data.province;
      //         _this.orderForm.deliveryDetail.city = res.data.data.city;
      //         _this.orderForm.deliveryDetail.addressFirst =
      //           res.data.data.address;
      //         _this.orderForm.deliveryDetail.contractName = res.data.data.name;
      //         _this.orderForm.deliveryDetail.phone = res.data.data.phone;

      //         if (
      //           _this.initialDataProvinceChina &&
      //           _this.initialDataProvinceChina.length > 0
      //         ) {
      //           _this.initialDataProvinceChina.forEach((d, i) => {
      //             if (d.nameCn == res.data.data.province) {
      //               _this.orderForm.deliveryDetail.provinceId = d.id;
      //               _this.deliveryDetail.provinceId = d.id;
      //             }
      //           });
      //         }
      //       }
      //     })
      //     .catch(error => {
      //       console.log(error);
      //     });
      // }
    },
    changeShippingAddressType() {
      let _this = this;
      if (!_this.fbaChecked) {
        _this.isJP = false;
        _this.orderForm.shippingDetail.contractName = "";
        _this.orderForm.shippingDetail.phone = "";
        _this.orderForm.shippingDetail.fbaWarehouseCode = "";

        _this.orderForm.localLanguage.contractName = "";
        _this.orderForm.localLanguage.country = "";
        _this.orderForm.localLanguage.province = "";
        _this.orderForm.localLanguage.city = "";
        _this.orderForm.localLanguage.addressFirst = "";
        _this.orderForm.localLanguage.addressSecond = "";
      }
    },
    queryAddress(type) {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/address/query',
        params: {
          type: type
        }
      })
        .then(res => {
          console.log("shipping adress", res);

          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              this.shippingList = res.data.data;
              this.shippingList.forEach((d, i) => {
                if (d.defaultAddress) {
                  this.selectShippingAddress(d.id);
                }
              });
            } else {
              this.shippingList = [];
            }
          } else {
            _this.$message.error(res.data.message);
            this.shippingList = [];
          }
          _this.queryFbaAddress();
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectShippingAddress(id) {
      this.shippingList.forEach((d, i) => {
        if (d.id == id) {
          this.shippingId = id;
          this.orderForm.deliveryDetail.province = d.province;
          this.orderForm.deliveryDetail.city = d.city;
          this.orderForm.deliveryDetail.addressFirst = d.address;
          this.orderForm.deliveryDetail.contractName = d.name;
          this.orderForm.deliveryDetail.phone = d.phone;
        }
      });
    },
    addressDialogPop() {
      this.shippingForm = {
        id: "",
        country: "",
        province: "",
        city: "",
        fbacode: "",
        address: "",
        name: "",
        phone: "",
        zipcode: "",
        type: "SHIPPING",
        defaultAddress: false
      };
      this.addressDialogVisible = true;
    },
    closeAddressPanel() {
      this.addressDialogVisible = false;
      this.queryAddress("SHIPPING");
    },
    loadGoodsType() {
      let _this = this;
      _this.$request1
        .get(
          '/order/goods-type-list',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(res => {
          if (res.status == 200) {
            console.log(res);
            _this.goodsTypeList = res.data;
          } else {
            _this.$message.error("加载初始化数据失败loadGoodsType");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectWarehouse() {
      this.warehouseData.forEach((item, index) => {
        if (item.id == this.warehouseId) {
          this.getMapForm(item);
          this.userCarry[0].title = item.name;
          this.userCarry[0].address = item.address;
          this.userCarry[0].name = item.receiptPersonName;
          this.userCarry[0].phone = item.phone;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#sp-amap {
  position: fixed;
  top: 0;
  right: 100%;
  &.isOpen {
    position: relative;
    right: 0;
  }
}
.download-template {
  margin-right: 10px;
  color: #409eff;
  &:hover {
    text-decoration: underline;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/neworder.vue